import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ShopNavigation } from '../components/shop/ShopNavigation';
import { ShopFooter } from '../components/shop/ShopFooter';
import { CartItem } from '../components/shop/CartItem';
import { ShippingMessage } from '../components/shop/ShippingMessage';
import { useCart } from '../contexts/CartContext';
import { formatMoney, shipping } from '../lib/shopify';
export function Cart() {
  const {
    lines,
    subtotal,
    currencyCode,
    checkout,
    checkoutState
  } = useCart();
  useEffect(() => {
    document.title = 'Cart — BEAT Soda';
  }, []);
  return <div className="flex min-h-screen w-full flex-col bg-beat-black font-sans text-white antialiased" data-id="element-310" data-mp="fr9nmooy8fv8">
      <ShopNavigation data-id="element-311" data-mp="athkszmrn9c9" />

      <main className="flex-1 px-5 py-14 md:px-10 md:py-20" data-id="element-312" data-mp="au168qbmkfv1">
        <div className="mx-auto max-w-[1000px]" data-id="element-313" data-mp="5u4xyevwa29o">
          <h1 className="text-[12vw] font-medium leading-[1.05] tracking-tight sm:text-5xl md:text-6xl" data-id="element-314" data-mp="5stu6f2g8uik">
            Your cart
          </h1>

          {lines.length === 0 ? <div className="mt-10" data-id="element-315" data-mp="29ij4lfqzvg1l">
              <p className="text-lg text-white/50" data-id="element-316" data-mp="29hhrz6ubylhr">Nothing here yet.</p>
              <Link to="/shop" className="mt-8 inline-flex min-h-[54px] items-center rounded-full bg-beat-red px-7 text-base font-medium text-white transition-colors duration-150 hover:bg-white hover:text-beat-black" data-id="element-317" data-mp="2ebm0huj8v1ky">
                Shop BEAT
              </Link>
            </div> : <div className="mt-12 grid gap-12 lg:grid-cols-[1.4fr_1fr] lg:gap-16" data-id="element-318" data-mp="2x8vnflns2x6y">
              <ul data-id="element-319" data-mp="2x6j3x42dgers">
                {lines.map(line => <CartItem key={line.product.handle} line={line} data-id="element-320" data-mp="2j8cfsfn85t5b" />)}
              </ul>

              <aside className="h-fit rounded-3xl bg-white/5 p-7 lg:sticky lg:top-28" data-id="element-321" data-mp="2n94o96o9vu0j">
                <h2 className="text-lg font-medium tracking-tight" data-id="element-322" data-mp="17t5wh5yyqamg">Summary</h2>

                <div className="mt-6 flex items-baseline justify-between" data-id="element-323" data-mp="1bvsslj2o2hpg">
                  <span className="text-base text-white/55" data-id="element-324" data-mp="3ei7tpq6j0tzm">Subtotal</span>
                  <span className="text-xl font-medium tabular-nums" data-id="element-325" data-mp="3ekaiy7zuuj3a">
                    {formatMoney(subtotal, currencyCode)}
                  </span>
                </div>

                <p className="mt-3 text-sm leading-relaxed text-white/45" data-id="element-326" data-mp="34qtqp8fd9c1q">
                  {shipping.note}
                </p>

                <ShippingMessage subtotal={subtotal} className="mt-5" data-id="element-327" data-mp="2zrh4mpwbk907" />

                <button type="button" onClick={checkout} disabled={checkoutState === 'loading'} className="mt-7 inline-flex min-h-[54px] w-full items-center justify-center rounded-full bg-beat-red px-7 text-base font-medium text-white transition-colors duration-150 hover:bg-white hover:text-beat-black disabled:opacity-60" data-id="element-328" data-mp="2vtb1druowbk1">
                  {checkoutState === 'loading' ? 'Taking you to checkout…' : 'Checkout'}
                </button>

                <Link to="/shop" className="mt-3 inline-flex min-h-[48px] w-full items-center justify-center text-base text-white/50 transition-colors duration-150 hover:text-white" data-id="element-329" data-mp="nkwfrv7qsrsx">
                  Continue shopping
                </Link>

                {checkoutState === 'unavailable' && <p className="mt-5 text-sm leading-relaxed text-white/45" data-id="element-330" data-mp="11dm62bub0ivu">
                    Checkout opens once Shopify is connected. Add the store
                    domain and Storefront token in{' '}
                    <span className="text-white/70" data-id="element-331" data-mp="dlx5673f2m3a">lib/shopify.ts</span>.
                  </p>}
                {checkoutState === 'error' && <p className="mt-5 text-sm text-white/45" data-id="element-332" data-mp="iml73nt6onca">
                    Something went wrong reaching checkout. Try again.
                  </p>}
              </aside>
            </div>}
        </div>
      </main>

      <ShopFooter data-id="element-333" data-mp="32wu68u6nbtgy" />
    </div>;
}